import React from 'react';
import { connect } from 'react-redux';
import { DialogBox } from 'global-components-library';
import { hideAdminModal } from '../../redux/actions/A_Admin_Alert_Modal';

const AdminAlertModal = (props) => {

    const {
        title,
        content,
        accept,
        cancel,
        onAccept,
        onCancel
    } = props.data;

    const onAcceptHandler = () => {
        props.onHideAdminAlertModal();
        if(onAccept){
            onAccept();
        }
    }

    const onCancelHandler = () => {
        props.onHideAdminAlertModal();
        if(onCancel){
            onCancel();
        }
    }

    return(
        <DialogBox
             title={title}
             content={content}
             show={props.isModalOpen}
             accept={accept}
             cancel={cancel}
             onAccept={accept && onAcceptHandler}
             onCancel={cancel && onCancelHandler}
        />
    )
}

const mapStateToProps = (state) => {
    const {isModalOpen, data} = state.adminModal;

    return {
        isModalOpen,
        data
    }
}

const mapDispatchToProps = {
    onHideAdminAlertModal: () => hideAdminModal()
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminAlertModal);


// WEBPACK FOOTER //
// ./src/components/Alerts/AdminAlertModal.jsx